import CreateCampaign from '@/Component/Brand/MyCampaigns/CreateCampaign'

const EditCampaignPage = async ({ params }: { params: Promise<{ slug: string | string[] }>; }) => {
    const resolvedParams = await params;
    const campaign_slug = Array.isArray(resolvedParams.slug) ? resolvedParams.slug[0] : resolvedParams.slug;

    return <CreateCampaign slug={campaign_slug} />;
};

export default EditCampaignPage;
